<template>
  <div id="instagramFeed" style="padding-bottom: 15px;">
    <div style="max-width: 1000px; margin: auto; margin-bottom: 150px;" class="powr-instagram-feed" id="2c1afe03_1617280983"></div>
    <script type="application/javascript" src="https://www.powr.io/powr.js?platform=vuejs"></script>
  </div>
</template>

<script>

export default {
  name: 'instagramFeed',
  data() {
    return{
    }
   },
   components: {
   },
   computed: {
   },
   methods: {
   },
}
</script>

<style scoped>

</style>
